module.exports = __webpack_public_path__ + "static/media/2023-Sub-Exclusive-Feature-Banner-lg@1x.1f1c11bc.webp";